import Vue from 'vue';
import store from 'store/index';
import App from 'App.vue';
import router from 'router';
import Moment from 'moment';
import 'config';
import _ from 'lodash';
import Api from 'services/Api';
import { Plugin } from 'vue-fragment'

/**
 * Deeply maps arrays and objects using lodash.
 *
 * Note: Move to a better, more specific location.
 */
_.mixin({
    deeply: map => (object, callback) =>
        map(_.mapValues(object, (value) => {
            if (_.isPlainObject(value)) {
                return _.deeply(map)(value, callback);
            }

            if (_.isArray(value)) {
                return _.map(value, item => _.deeply(map)(item, callback));
            }

            return value;
        }), callback),
});

Vue.prototype.$watchAll = function(props, callback) {
    props.forEach(prop => {
        // Pass the prop as the first argument to our callback
        this.$watch(prop, callback.bind(null, prop));
    });
};

Vue.use(Plugin);

const vue = new Vue({
    store,
    router,
    Moment,
    render: h => h(App),
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js